import React from "react";
import Routes from "./Routes";
import { AuthProvider } from './contexts/AuthContext';
import './i18n'
import { Toaster } from 'sonner';


function App() {
  return (
    
       <>
      <Routes />
      <Toaster position="top-center" richColors />
    </>

  );
}

export default App;
